import { normalizeLevel } from '@fytness/shared';

export type PowerSyncLogLevelName =
  | 'TRACE'
  | 'DEBUG'
  | 'INFO'
  | 'WARN'
  | 'ERROR'
  | 'OFF';

/**
 * Maps the app's `EXPO_PUBLIC_LOG_LEVEL` (a pino level, shared with the app
 * logger via {@link normalizeLevel}) onto a PowerSync `LogLevel` key, so the
 * native/web PowerSync database logs at the environment's level instead of a
 * hardcoded DEBUG.
 *
 * Returning the enum *key* keeps this pure: the platform-specific `LogLevel`
 * object is looked up at the call site (`LogLevel[resolveName(...)]`), so this
 * stays free of the heavy `@powersync/*` runtime imports and unit-testable
 * under node.
 */
export class PowerSyncLogLevel {
  static resolveName(level?: string): PowerSyncLogLevelName {
    switch (normalizeLevel(level)) {
      case 'trace':
        return 'TRACE';
      case 'debug':
        return 'DEBUG';
      case 'info':
        return 'INFO';
      case 'warn':
        return 'WARN';
      case 'error':
      case 'fatal':
        return 'ERROR';
      case 'silent':
        return 'OFF';
      default:
        return 'WARN';
    }
  }
}
